import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "@/contexts/AuthContext";
import { SEO } from "@/components/SEO";

export default function Auth() {
  const navigate = useNavigate();
  const { user } = useAuthContext();

  useEffect(() => {
    // If already logged in, redirect to app
    if (user) {
      navigate("/app");
      return;
    }

    // Redirect to login page for returning users
    navigate("/login");
  }, [user, navigate]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <SEO 
        title="Sign In"
        description="Sign in to your BrainWrk account to access AI-powered learning paths and team training tools."
        canonicalUrl="/auth"
        noIndex={true}
      />
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary" />
        <p className="mt-4 text-muted-foreground">Redirecting to login...</p>
      </div>
    </div>
  );
}
